/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *
 */

import I18N from '@utils/i18n.base';
import type { SearchResult } from '@models/cooking/search';
import type { SearchHit } from '@components/search/types';

export function getCookingItemLink(result: Pick<SearchResult, 'type' | 'id'>): string {
    switch (result.type) {
        case 'recipe':
            return `/cooking/recipes/${result.id}`;
        case 'ingredient':
            return `/cooking/ingredients/${result.id}`;
        case 'tool':
            return `/cooking/tools/${result.id}`;
        case 'cuisine-type':
            return `/cooking/cuisine-types/${result.id}`;
        default:
            return '#';
    }
}

export function getCookingItemIcon(type: string): string {
    switch (type) {
        case 'recipe':
            return 'restaurant_menu';
        case 'ingredient':
            return 'restaurant';
        case 'tool':
            return 'build';
        case 'cuisine-type':
            return 'local_dining';
        default:
            return 'search';
    }
}

export function getCookingItemTypeLabel(type: string): string {
    switch (type) {
        case 'recipe':
            return I18N.cooking.recipeList;
        case 'ingredient':
            return I18N.cooking.ingredients;
        case 'tool':
            return I18N.cooking.tools;
        case 'cuisine-type':
            return I18N.cooking.cuisineType;
        default:
            return type;
    }
}

export function cookingResultToHit(result: SearchResult): SearchHit {
    return {
        id: `${result.type}-${result.id}`,
        title: result.name,
        subtitle: getCookingItemTypeLabel(result.type),
        icon: getCookingItemIcon(result.type),
        to: getCookingItemLink(result),
    };
}
